import {Component, Inject, Input} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-pos-discount-dialog',
  templateUrl: './pos-pax-no-dialog.component.html',
  styleUrls: ['./pos-pax-no-dialog.component.scss'],
})
export class PosPaxNoDialogComponent {

  @Input()
  paxNo: number;

  constructor(private dialogRef: MatDialogRef<PosPaxNoDialogComponent>, @Inject(MAT_DIALOG_DATA) private data: any) {
    this.paxNo = data.paxNo;
  }

  submit() {
    this.dialogRef.close({
      paxNo: this.paxNo
    });
  }
}
